import Functions from '@client/style/Functions';
import { Breakpoints } from '@client/style/Variables';
import { css } from 'styled-components';

export const pixels = {
	mobile: 180,
	tablet: 260,
};

export const PixelsPerHour = (func: (pph: number) => string) => {
	return css`
		${func(pixels.mobile)}

		${Functions.breakpoint(Breakpoints.tablet)} {
			${func(pixels.tablet)}
		}
	`;
};
